import React from 'react';
import { Button, CancelButton } from '../../../components/Button';
import { ActionModal } from '../../../components/Modal';
import { usePdfTemplateContext } from '../PdfTemplateEditorContext';

interface PdfTemplateJsonPreviewModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function PdfTemplateJsonPreviewModal({ open, setOpen }: PdfTemplateJsonPreviewModalProps) {
  const { documentProperties, components, editorSettings, setComponents, setEditorSettings, updateDocumentProperties } =
    usePdfTemplateContext();

  const footer = (
    <div className='flex justify-between gap-2'>
      <Button
        text={'Paste'}
        onClick={() => {
          navigator.clipboard.readText().then(text => {
            try {
              const json = JSON.parse(text);
              if (json.documentProperties) updateDocumentProperties(json.documentProperties);
              if (json.components) setComponents(json.components);
              if (json.editorSettings) setEditorSettings(json.editorSettings);

              console.log('Pasted JSON:', json);
            } catch (error) {
              console.error('Invalid JSON:', error);
            }
          });
        }}
      />

      <div className='flex gap-2'>
        <CancelButton onClick={() => setOpen(false)} />
        <Button
          text={'Copy'}
          onClick={() => {
            navigator.clipboard.writeText(
              JSON.stringify(
                {
                  document: documentProperties,
                  components: components,
                  settings: editorSettings,
                },
                null,
                2,
              ),
            );
          }}
        />
      </div>
    </div>
  );

  return (
    <ActionModal title={'Template JSON'} open={open} setOpen={setOpen} footer={footer}>
      <pre className='max-h-[60vh] overflow-auto rounded bg-gray-100 p-2 text-xs'>
        {JSON.stringify(
          {
            document: documentProperties,
            components: components,
            settings: editorSettings,
          },
          null,
          2,
        )}
      </pre>
    </ActionModal>
  );
}
